export const categories = [
  { id: 'hot', name: '热门综艺', slug: 'hot', icon: 'ri-fire-line' },
  { id: 'reality', name: '真人秀', slug: 'reality', icon: 'ri-user-star-line' },
  { id: 'comedy', name: '搞笑综艺', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { id: 'talk', name: '访谈节目', slug: 'talk', icon: 'ri-chat-smile-2-line' },
  { id: 'music', name: '音乐综艺', slug: 'music', icon: 'ri-music-line' },
  { id: 'competition', name: '竞技比赛', slug: 'competition', icon: 'ri-trophy-line' },
  { id: 'travel', name: '旅行户外', slug: 'travel', icon: 'ri-road-map-line' },
  { id: 'food', name: '美食生活', slug: 'food', icon: 'ri-restaurant-line' },
];

export interface Show {
  id: number;
  title: string;
  category: string;
  coverImage: string;
  description: string;
  episodes: number;
  rating: number;
  host: string;
  year: number;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  views: string;
}

export const shows: Show[] = [
  {
    id: 1,
    title: '欢乐大本营第十季',
    category: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20Chinese%20variety%20show%20stage%20with%20hosts%20and%20guests%20laughing%2C%20warm%20studio%20lighting%2C%20entertainment%20show%20poster%20style%2C%20vibrant%20and%20energetic%20composition%2C%20clean%20and%20professional%20design&width=800&height=600&seq=show-01&orientation=landscape',
    description: '国民级综艺节目欢乐大本营迎来全新第十季，主持人团队全面升级，更精彩的游戏环节，更爆笑的嘉宾互动，每周六晚八点准时带来欢乐盛宴。本季新增"全民挑战"环节，让观众也能参与其中。',
    episodes: 24,
    rating: 9.5,
    host: '何老师、娜娜、维嘉',
    year: 2026,
    tags: ['搞笑', '游戏', '明星'],
    isHot: true,
    isNew: true,
    views: '2.3亿',
  },
  {
    id: 2,
    title: '奔跑吧兄弟第九季',
    category: 'reality',
    coverImage: 'https://readdy.ai/api/search-image?query=Outdoor%20Chinese%20reality%20show%20running%20competition%20scene%2C%20celebrities%20in%20colorful%20sportswear%20racing%2C%20dynamic%20action%20pose%2C%20bright%20sunlight%2C%20energetic%20atmosphere%2C%20professional%20entertainment%20photography&width=800&height=600&seq=show-02&orientation=landscape',
    description: '国内顶级户外真人秀再度起航！全新阵容，全新挑战，跑男团带你领略祖国大好河山的同时，完成一个个惊险刺激的任务。本季首次引入"国际对抗赛"模式，精彩不容错过。',
    episodes: 20,
    rating: 9.3,
    host: '邓超、李晨、杨颖',
    year: 2026,
    tags: ['真人秀', '户外', '竞技'],
    isHot: true,
    isNew: true,
    views: '1.8亿',
  },
  {
    id: 3,
    title: '脱口秀大会第六季',
    category: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=Standup%20comedy%20stage%20with%20spotlight%20and%20microphone%2C%20comedian%20performing%20on%20stage%2C%20warm%20theatrical%20lighting%2C%20dark%20background%20with%20audience%20silhouettes%2C%20professional%20show%20photography&width=800&height=600&seq=show-03&orientation=landscape',
    description: '最火爆的语言类综艺节目回来了！全国各地的脱口秀演员齐聚一堂，用幽默犀利的语言讲述生活、吐槽社会。全新赛制升级，更有国际知名脱口秀演员作为特邀嘉宾空降现场。',
    episodes: 16,
    rating: 9.1,
    host: '李诞、池子',
    year: 2026,
    tags: ['搞笑', '脱口秀', '语言'],
    isHot: true,
    isNew: false,
    views: '1.5亿',
  },
  {
    id: 4,
    title: '向往的生活第八季',
    category: 'travel',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20countryside%20landscape%20with%20traditional%20wooden%20house%2C%20green%20mountains%20and%20rice%20fields%2C%20warm%20golden%20hour%20sunlight%2C%20peaceful%20and%20idyllic%20atmosphere%2C%20cinematic%20nature%20photography&width=800&height=600&seq=show-04&orientation=landscape',
    description: '慢综艺标杆之作再度回归！蘑菇屋家族来到云南大理，在苍山洱海之间过着自给自足的田园生活。每一期都有老朋友和新朋友做客，带来美食和故事，治愈你的心灵。',
    episodes: 14,
    rating: 9.4,
    host: '黄磊、何炅、彭昱畅',
    year: 2026,
    tags: ['生活', '美食', '旅行'],
    isHot: true,
    isNew: false,
    views: '1.2亿',
  },
  {
    id: 5,
    title: '极限挑战第十季',
    category: 'reality',
    coverImage: 'https://readdy.ai/api/search-image?query=Urban%20adventure%20challenge%20scene%20with%20Chinese%20celebrities%20solving%20puzzles%20in%20city%2C%20modern%20skyscrapers%20background%2C%20exciting%20and%20suspenseful%20mood%2C%20professional%20entertainment%20show%20photography&width=800&height=600&seq=show-05&orientation=landscape',
    description: '男人帮再次集结，第十季全面升级！更大的城市挑战，更烧脑的推理环节，更意想不到的反转剧情。本季融入"科技探秘"元素，在智慧城市中展开前所未有的极限挑战。',
    episodes: 18,
    rating: 9.2,
    host: '黄渤、孙红雷、张艺兴',
    year: 2026,
    tags: ['真人秀', '挑战', '推理'],
    isHot: false,
    isNew: true,
    views: '9800万',
  },
  {
    id: 6,
    title: '歌手2026',
    category: 'music',
    coverImage: 'https://readdy.ai/api/search-image?query=Grand%20music%20stage%20with%20colorful%20lighting%20effects%2C%20singer%20performing%20with%20band%2C%20dramatic%20spotlight%2C%20concert%20atmosphere%2C%20professional%20music%20show%20photography%2C%20epic%20and%20emotional&width=800&height=600&seq=show-06&orientation=landscape',
    description: '华语乐坛顶级音乐竞技节目全新升级！集结两岸三地最优秀的歌手同台竞技，用最纯粹的歌声征服观众和评审。全新"创作赛道"和"翻唱赛道"双线并行，展现音乐的无限可能。',
    episodes: 13,
    rating: 9.6,
    host: '何炅、沈梦辰',
    year: 2026,
    tags: ['音乐', '竞技', '歌唱'],
    isHot: true,
    isNew: true,
    views: '3.1亿',
  },
  {
    id: 7,
    title: '明星大侦探第九季',
    category: 'competition',
    coverImage: 'https://readdy.ai/api/search-image?query=Mystery%20detective%20scene%20with%20dim%20dramatic%20lighting%2C%20crime%20scene%20investigation%20setup%2C%20magnifying%20glass%20and%20clues%2C%20suspenseful%20atmosphere%2C%20professional%20tv%20show%20photography&width=800&height=600&seq=show-07&orientation=landscape',
    description: '国内首档明星角色扮演推理综艺回归！每期一个全新案件，明星玩家化身侦探和嫌疑人，通过搜证、推理、投票找出真凶。全新AR技术加持，沉浸式案发现场体验升级。',
    episodes: 16,
    rating: 9.0,
    host: '何炅、撒贝宁',
    year: 2026,
    tags: ['推理', '悬疑', '角色扮演'],
    isHot: false,
    isNew: true,
    views: '1.1亿',
  },
  {
    id: 8,
    title: '中餐厅第八季',
    category: 'food',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20restaurant%20interior%20with%20warm%20lighting%2C%20delicious%20Chinese%20cuisine%20dishes%20on%20table%2C%20chefs%20cooking%20in%20open%20kitchen%2C%20cozy%20dining%20atmosphere%2C%20professional%20food%20photography&width=800&height=600&seq=show-08&orientation=landscape',
    description: '中华美食文化推广节目再出发！本季中餐厅开到了日本京都，在古都氛围中传播中华美食。明星合伙人们将经营一家融合中日文化特色的创意中餐厅，用美食搭建文化交流的桥梁。',
    episodes: 12,
    rating: 8.9,
    host: '黄晓明、林述巍',
    year: 2026,
    tags: ['美食', '文化', '经营'],
    isHot: false,
    isNew: false,
    views: '8500万',
  },
  {
    id: 9,
    title: '这！就是街舞第六季',
    category: 'competition',
    coverImage: 'https://readdy.ai/api/search-image?query=Dynamic%20street%20dance%20battle%20stage%20with%20dancers%20performing%2C%20vibrant%20urban%20graffiti%20background%2C%20dramatic%20stage%20lighting%2C%20hiphop%20culture%20atmosphere%2C%20professional%20dance%20show%20photography&width=800&height=600&seq=show-09&orientation=landscape',
    description: '中国最燃的街舞竞技节目六度开战！全球顶尖舞者汇聚一堂，四大战队巅峰对决。全新"世界赛"模式，中国舞者将与世界各国冠军一较高下，用舞蹈语言征服世界。',
    episodes: 15,
    rating: 9.3,
    host: '易烊千玺、王一博',
    year: 2026,
    tags: ['街舞', '竞技', '潮流'],
    isHot: true,
    isNew: false,
    views: '2.1亿',
  },
  {
    id: 10,
    title: '圆桌派第七季',
    category: 'talk',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20round%20table%20discussion%20setting%20with%20warm%20lighting%2C%20cultural%20intellectuals%20chatting%2C%20bookshelves%20background%2C%20tea%20and%20refreshments%2C%20sophisticated%20talk%20show%20atmosphere%2C%20professional%20photography&width=800&height=600&seq=show-10&orientation=landscape',
    description: '最下饭的文化访谈节目第七季如约而至！窦文涛携手各界文化名人，围坐圆桌畅聊社会热点、文化现象和人生百态。本季议题更加多元，从AI科技到传统文化，从社会心理到国际局势，无所不谈。',
    episodes: 24,
    rating: 9.4,
    host: '窦文涛',
    year: 2026,
    tags: ['访谈', '文化', '社会'],
    isHot: false,
    isNew: false,
    views: '6800万',
  },
  {
    id: 11,
    title: '喜剧之王争霸赛第三季',
    category: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=Comedy%20competition%20stage%20with%20colorful%20set%20design%2C%20comedians%20performing%20sketch%20comedy%2C%20bright%20theatrical%20lighting%2C%20audience%20laughing%2C%20professional%20comedy%20show%20photography&width=800&height=600&seq=show-11&orientation=landscape',
    description: '全民喜剧竞演节目第三季爆笑回归！小品、相声、默剧、即兴喜剧等多种喜剧形式同台竞技。全新"喜剧实验室"环节，选手需在限定时间内即兴创作并表演，挑战喜剧人的极限创造力。',
    episodes: 12,
    rating: 8.8,
    host: '沈腾、贾玲',
    year: 2026,
    tags: ['喜剧', '搞笑', '竞演'],
    isHot: false,
    isNew: true,
    views: '9200万',
  },
  {
    id: 12,
    title: '花儿与少年第六季',
    category: 'travel',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20European%20cityscape%20with%20young%20travelers%20exploring%2C%20sunny%20day%2C%20historic%20architecture%20background%2C%20adventure%20and%20friendship%20theme%2C%20warm%20travel%20photography%20style&width=800&height=600&seq=show-12&orientation=landscape',
    description: '青春旅行真人秀第六季全新出发！本季花少团踏上丝绸之路，从西安出发穿越中亚最终抵达土耳其。沿途体验多元文化，感受历史与现代的交融，在旅途中发现世界也发现自我。',
    episodes: 14,
    rating: 8.7,
    host: '杨幂、刘昊然',
    year: 2026,
    tags: ['旅行', '青春', '文化'],
    isHot: false,
    isNew: false,
    views: '7600万',
  },
];

export const testimonials = [
  { id: 1, name: '小明同学', avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Chinese%20man%2C%20friendly%20smile%2C%20clean%20white%20background%2C%20professional%20portrait%20photography&width=200&height=200&seq=avatar-01&orientation=squarish', content: '星辰影院真的太棒了！综艺更新速度超快，而且全是高清画质，一点都不卡顿。每天晚上下班回家就靠它放松了！', rating: 5 },
  { id: 2, name: '综艺达人Lucy', avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Chinese%20woman%2C%20warm%20smile%2C%20clean%20white%20background%2C%20professional%20portrait%20photography&width=200&height=200&seq=avatar-02&orientation=squarish', content: '追了三年的忠实用户了，从第一季到现在的所有热门综艺都有，分类清晰，找节目超方便。强烈推荐给所有综艺爱好者！', rating: 5 },
  { id: 3, name: '老王爱看综艺', avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20middle-aged%20Chinese%20man%2C%20friendly%20expression%2C%20clean%20white%20background%2C%20professional%20portrait%20photography&width=200&height=200&seq=avatar-03&orientation=squarish', content: '页面简洁没有乱七八糟的广告弹窗，观看体验非常好。家里人现在都用星辰影院看综艺，已经成了我们家的标配了。', rating: 5 },
];

export const stats = [
  { label: '综艺节目', value: '5000+' },
  { label: '高清片源', value: '10万+' },
  { label: '日均用户', value: '300万+' },
  { label: '好评率', value: '98.5%' },
];

export interface Article {
  id: number;
  title: string;
  category: string;
  coverImage: string;
  summary: string;
  content: string;
  author: string;
  publishDate: string;
  views: number;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: 1,
    title: '《歌手2026》首播收视率破纪录，华语乐坛再掀音乐狂潮',
    category: 'music',
    coverImage: 'https://readdy.ai/api/search-image?query=Grand%20music%20award%20ceremony%20stage%20with%20golden%20trophy%20and%20spotlight%2C%20prestigious%20atmosphere%2C%20professional%20event%20photography&width=1200&height=675&seq=article-01&orientation=landscape',
    summary: '备受瞩目的《歌手2026》于上周五晚首播，开播即创下全国收视率3.8%的佳绩，成为今年综艺市场当之无愧的现象级节目。',
    content: '备受瞩目的《歌手2026》于上周五晚首播，开播即创下全国收视率3.8%的佳绩，成为今年综艺市场当之无愧的现象级节目。\n\n本季《歌手》在赛制上进行了全面革新，首次引入"创作赛道"与"翻唱赛道"双线并行的模式。选手既可以选择演唱自己的原创作品，也可以精心改编经典老歌，大大丰富了节目的音乐性。\n\n首期节目中，来自台湾的独立音乐人陈绮贞以一首原创歌曲《时光的回声》震撼全场，获得七位评审一致满分，成为本季首位"金曲歌手"。\n\n节目总导演洪涛在接受采访时表示："这一季我们希望回归音乐本质，让歌手用作品说话。双赛道的设计给了不同类型音乐人平等的展示机会，也给了观众更多元的音乐体验。"\n\n据悉，《歌手2026》第二期将迎来首位国际踢馆歌手——曾获格莱美提名的日本歌手米津玄师，届时他将带来怎样的惊喜，让我们拭目以待。',
    author: '星辰编辑组',
    publishDate: '2026-07-28',
    views: 128000,
    tags: ['歌手2026', '收视率', '音乐综艺'],
  },
  {
    id: 2,
    title: '《奔跑吧兄弟》第九季首站录制地曝光，这次竟然去了这里！',
    category: 'reality',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Zhangjiajie%20mountain%20landscape%20with%20misty%20peaks%20and%20glass%20bridge%2C%20spectacular%20natural%20scenery%2C%20dramatic%20lighting%2C%20travel%20photography&width=1200&height=675&seq=article-02&orientation=landscape',
    summary: '《奔跑吧兄弟》第九季首站录制地确定为湖南张家界，跑男团将在天门山玻璃栈道上完成惊险刺激的挑战任务。',
    content: '《奔跑吧兄弟》第九季首站录制地确定为湖南张家界，跑男团将在天门山玻璃栈道上完成惊险刺激的挑战任务。\n\n据节目组透露，本季《奔跑吧》将主打"壮美中国"主题，每期前往一个国内知名自然或人文景观进行录制。首站选择张家界，正是看中了其独一无二的地貌特征和丰富的拍摄可能性。\n\n"在天门山玻璃栈道上做游戏，光想想就腿软，"跑男团成员李晨在社交媒体上发文称，"但张家界的风景真的太震撼了，值得！"\n\n本季跑男阵容也进行了微调，除保留邓超、李晨、杨颖三位元老成员外，新增了两位年轻艺人——时代少年团的马嘉祺和演员赵今麦，为新一季注入新鲜血液。\n\n节目预计于8月中旬在星辰影院首播，每周五晚8点更新。',
    author: '星辰编辑组',
    publishDate: '2026-07-25',
    views: 96000,
    tags: ['奔跑吧兄弟', '张家界', '真人秀'],
  },
  {
    id: 3,
    title: '《脱口秀大会》第六季总决赛：笑中带泪的年度最佳语言盛宴',
    category: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=Comedy%20club%20stage%20with%20spotlight%20and%20standing%20ovation%2C%20emotional%20comedian%20bowing%2C%20warm%20atmosphere%2C%20professional%20event%20photography&width=1200&height=675&seq=article-03&orientation=landscape',
    summary: '《脱口秀大会》第六季总决赛圆满落幕，新人黑马用一段关于亲情的脱口秀征服全场，笑中带泪的表演堪称年度最佳。',
    content: '《脱口秀大会》第六季总决赛圆满落幕，新人黑马用一段关于亲情的脱口秀征服全场，笑中带泪的表演堪称年度最佳。\n\n经过三个月的激烈角逐，来自东北的新人脱口秀演员小北凭借总决赛上一段关于"我和我妈的日常"的脱口秀，以绝对优势夺得本季冠军。在表演中，他用幽默的方式讲述了与母亲相处的点点滴滴，从催婚到学用智能手机，笑料百出却又温情脉脉。\n\n"好的脱口秀不是让人尬笑，而是笑着笑着就哭了，"评委李诞在点评时动情地说，"小北做到了。"\n\n本季《脱口秀大会》全网播放量突破15亿，相关话题阅读量超80亿，#脱口秀大会第六季# 持续霸占微博热搜。节目的成功也带动了线下脱口秀演出市场的火爆，全国各大城市的脱口秀俱乐部门票一票难求。',
    author: '星辰编辑组',
    publishDate: '2026-07-20',
    views: 156000,
    tags: ['脱口秀大会', '总决赛', '冠军'],
  },
  {
    id: 4,
    title: '《这！就是街舞》第六季世界赛：中国舞者首次包揽前三',
    category: 'competition',
    coverImage: 'https://readdy.ai/api/search-image?query=Triumphant%20dance%20crew%20holding%20trophy%20on%20stage%2C%20confetti%20falling%2C%20celebration%20moment%2C%20dramatic%20lighting%2C%20professional%20sports%20photography&width=1200&height=675&seq=article-04&orientation=landscape',
    summary: '在刚刚结束的《这！就是街舞》第六季世界赛中，中国舞者创造了历史，首次包揽冠亚季军，向世界展示了中国街舞的实力。',
    content: '在刚刚结束的《这！就是街舞》第六季世界赛中，中国舞者创造了历史，首次包揽冠亚季军，向世界展示了中国街舞的实力。\n\n本季世界赛汇集了来自美国、法国、日本、韩国等15个国家的顶级街舞选手，竞争异常激烈。在为期四周的比赛中，中国舞者凭借扎实的基本功和独特的创意编排，一路过关斩将。\n\n总决赛上，来自成都的B-boy阿杰以一组融合了中国武术元素的Breaking动作惊艳四座，获得裁判一致满分，夺得冠军。亚军和季军分别由上海的Popping舞者杨凯和广州的Hip-hop舞者JC获得。\n\n国际裁判、街舞传奇人物Mr. Wiggles在赛后表示："中国街舞的发展速度令人惊叹。他们不只是复制西方的风格，而是将自己的文化融入其中，创造出了独特的中国街舞语言。"',
    author: '星辰编辑组',
    publishDate: '2026-07-18',
    views: 210000,
    tags: ['街舞', '世界赛', '冠军'],
  },
  {
    id: 5,
    title: '《向往的生活》第八季大理站：蘑菇屋里的诗和远方',
    category: 'travel',
    coverImage: 'https://readdy.ai/api/search-image?query=Cozy%20wooden%20courtyard%20house%20in%20Dali%20Yunnan%20with%20Erhai%20lake%20view%2C%20golden%20sunset%2C%20peaceful%20rural%20life%2C%20cinematic%20photography&width=1200&height=675&seq=article-05&orientation=landscape',
    summary: '《向往的生活》第八季来到了云南大理，在苍山洱海旁，蘑菇屋家族用最质朴的方式诠释了什么叫做"向往的生活"。',
    content: '《向往的生活》第八季来到了云南大理，在苍山洱海旁，蘑菇屋家族用最质朴的方式诠释了什么叫做"向往的生活"。\n\n本季蘑菇屋选址在大理古城外的白族村落中，一栋由百年白族老宅改造而成的院落，推窗即见苍山雪，出门便是洱海月。\n\n"这里太美了，每天醒来看到苍山洱海，什么烦恼都忘了，"何炅在节目中感叹道。本季嘉宾阵容依旧强大，首批做客的嘉宾包括演员周迅、作家余华和音乐人赵雷。\n\n节目中，黄磊用当地的洱海鱼和新鲜菌菇烹饪了一道道美味佳肴；彭昱畅跟着白族老奶奶学习扎染技艺；周迅在洱海边即兴朗诵诗歌。每一帧画面都美得如诗如画，被网友称为"最治愈的综艺"。\n\n截至目前，《向往的生活》第八季豆瓣评分高达9.4分，延续了该系列一贯的高口碑。',
    author: '星辰编辑组',
    publishDate: '2026-07-15',
    views: 189000,
    tags: ['向往的生活', '大理', '慢综艺'],
  },
  {
    id: 6,
    title: '综艺市场2026年中盘点：五大趋势解读行业新风向',
    category: 'hot',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20TV%20production%20studio%20with%20multiple%20monitors%20showing%20different%20shows%2C%20professional%20broadcast%20environment%2C%20clean%20and%20futuristic%20design&width=1200&height=675&seq=article-06&orientation=landscape',
    summary: '2026年已过半，综艺市场呈现出哪些新趋势？从AI技术应用到跨文化融合，五大趋势解读综艺行业的新风向。',
    content: '2026年已过半，综艺市场呈现出哪些新趋势？从AI技术应用到跨文化融合，五大趋势解读综艺行业的新风向。\n\n趋势一：AI技术深度融入综艺制作。从《明星大侦探》的AR沉浸式案发现场，到各大音乐综艺的AI辅助评分系统，人工智能正在改变综艺的制作方式和观众体验。\n\n趋势二：跨文化内容成为主流。无论是《中餐厅》的海外经营，还是《花儿与少年》的丝路之旅，综艺节目越来越注重中外文化交流与碰撞。\n\n趋势三：短综艺形式崛起。在短视频平台的推动下，单集15-30分钟的短综艺正在获得越来越多年轻观众的青睐。\n\n趋势四：互动性大幅增强。观众不再只是被动观看，通过弹幕投票、实时互动等方式深度参与节目进程已成为新常态。\n\n趋势五：正能量与娱乐性并重。越来越多的综艺在提供娱乐的同时，注重传递积极向上的价值观，如环保、公益、文化传承等主题频频出现在综艺节目中。\n\n星辰影院将持续关注行业动态，为观众带来最新最热的综艺内容。',
    author: '星辰编辑组',
    publishDate: '2026-07-10',
    views: 67000,
    tags: ['综艺市场', '行业趋势', '2026'],
  },
];